export default "__VITE_ASSET__Bx2G3mMF__"